import { Button, type ButtonProps, DialogActions } from "@mui/material";

export type TActionButton = Omit<ButtonProps, "children"> & { label: string };

export interface IDialogFooterProps {
  actions: TActionButton[];
}

export const DialogFooter = ({ actions }: IDialogFooterProps) => (
  <DialogActions>
    {actions.map(({ label, variant = "outlined", ...buttonProps }) => (
      <Button key={label} variant={variant} {...buttonProps}>
        {label}
      </Button>
    ))}
  </DialogActions>
);
